import * as Contentful from 'contentful'
import { ContentProps } from '../../components/renderer'
import { TypeAssetImage } from './asset-image'

export enum IconListFieldSize {
  Small = 'Small',
  Large = 'Large',
}

export interface TypeItemIconListFields {
  internalName: Contentful.EntryFields.Symbol
  title?: Contentful.EntryFields.Symbol
  maxIconsPerRow: number
  minIconsPerRow: number
  icons: TypeAssetImage[] | undefined
  iconSize?: IconListFieldSize
  showAltTextUnderIcons?: boolean
}

export interface TypeIconListItemProps extends ContentProps<TypeAssetImage> {
  iconSize: IconListFieldSize
  showAltTextUnderIcon?: boolean
}

export type TypeItemIconList = Contentful.Entry<TypeItemIconListFields>
